import React, { memo } from "react";
import { Label } from "flowbite-react";
import { Surface } from "../../../../atoms/Surface";
import { FieldLabel } from "../../../../atoms/FieldLabel";
import { useTranslation } from "react-i18next";
import { FieldToggleControl } from "./FieldToggleControl";
import { Checkbox } from "flowbite-react";

type Props = {
  control: any;
};

export const CoreFieldsSection: React.FC<Props> = memo(({ control }) => {
  const { t } = useTranslation();
  const optionalFields: Array<{ key: string; label: string }> = [
    {
      key: "user_first_name",
      label: t("customRegistration.coreFields.firstName"),
    },
    {
      key: "user_last_name",
      label: t("customRegistration.coreFields.lastName"),
    },
    {
      key: "user_user_name",
      label: t("customRegistration.coreFields.username"),
    },
    {
      key: "user_country_code",
      label: t("customRegistration.coreFields.country"),
    },
    { key: "user_phone", label: t("customRegistration.coreFields.phone") },
    {
      key: "user_birth_date",
      label: t("customRegistration.coreFields.birthDate"),
    },
  ];

  return (
    <Surface>
      <div className="mb-4">
        <p className="text-gray-500 text-sm leading-tight">
          {t("customRegistration.coreFields.description")}
        </p>
      </div>

      <div className="space-y-2">
        <div className="grid grid-cols-1 gap-3 px-3 py-3 bg-gray-50 rounded border border-gray-200">
          <FieldLabel htmlFor="email">
            {t("customRegistration.coreFields.email")}
            <span className="text-gray-500 text-xs font-normal ml-1">
              {t("customRegistration.coreFields.emailNote")}
            </span>
          </FieldLabel>
          <div className="grid grid-cols-2 gap-4 md:gap-6 w-fit">
            <div className="grid grid-cols-[auto_1fr] items-center gap-2">
              <Checkbox
                id="email_visible"
                checked
                disabled
                className="cursor-not-allowed"
              />
              <Label
                htmlFor="email_visible"
                className="text-gray-600 text-sm cursor-not-allowed whitespace-nowrap"
              >
                {t("customRegistration.coreFields.visible")}
              </Label>
            </div>
            <div className="grid grid-cols-[auto_1fr] items-center gap-2">
              <Checkbox
                id="email_required"
                checked
                disabled
                className="cursor-not-allowed"
              />
              <Label
                htmlFor="email_required"
                className="text-gray-600 text-sm cursor-not-allowed whitespace-nowrap"
              >
                {t("customRegistration.coreFields.required")}
              </Label>
            </div>
          </div>
        </div>

        {optionalFields.map((f) => (
          <FieldToggleControl
            key={f.key}
            control={control}
            name={`fields.${f.key}`}
            label={f.label}
            supportsVerification={f.key === "user_phone"}
          />
        ))}
      </div>
    </Surface>
  );
});
